import { render } from "./BlockDocument.vue?vue&type=template&id=72af004d&scoped=true"
import script from "./BlockDocument.vue?vue&type=script&lang=js"
export * from "./BlockDocument.vue?vue&type=script&lang=js"

import "./BlockDocument.vue?vue&type=style&index=0&id=72af004d&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72af004d"]])

export default __exports__